import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"max-width":"15vw"} }
const _hoisted_2 = { class: "mt-8 mb-6" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "my-6" }
const _hoisted_6 = { class: "my-6" }
const _hoisted_7 = { class: "pl-8 text-caption" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "my-6" }
const _hoisted_11 = { class: "pl-8 text-caption" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { style: {"width":"285px"} }
const _hoisted_17 = ["src"]
const _hoisted_18 = { style: {"color":"white","font-size":"14px","font-weight":"500","text-align":"left","display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden","line-height":"1.2","max-width":"75px","min-width":"0"} }
const _hoisted_19 = { style: {"min-height":"calc(100vh - 115px)"} }

import { ref, onMounted, computed } from 'vue';
import { useClientsStore } from '@/store/clients';
import { format } from 'date-fns';
import { useRoute } from 'vue-router';

import GlobalSearchBar from '@/components/layout/GlobalSearchBar.vue' 
import ModulesTab from '@/components/layout/ModulesTab.vue' 
import RightDrawer from '@/components/layout/RightDrawer.vue';

import Sales from '@/components/modules/sales/Sales.vue'
import Quotations from '@/components/modules/quotations/Quotations.vue'
import Activities from '@/components/modules/activities/Activities.vue'
import Opportunities from '@/components/modules/opportunities/Opportunities.vue'
import Contacts from '@/components/modules/clients/contacts/Contacts.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  props: {
    id: {}
  },
  setup(__props: any) {

const tabs = [
  {label:'General', name:'general', icon:'mdi-view-dashboard-outline', disabled:true},
  { label:'Ventas', name:'sales', icon:'mdi-cash', disabled:false },
  { label:'Cotizaciones', name:'quotations', icon:'mdi-file-document-multiple-outline', disabled:false },
  { label:'Actividades', name:'activities', icon:'mdi-calendar', disabled:false },
  {label:'Cobranza', name:'collections', icon:'mdi-currency-usd', disabled:true},
  { label:'Oportunidades', name:'opportunities', icon:'mdi-cards-variant', disabled:false },
  {label:'Conversaciones', name:'conversations', icon:'mdi-chat-outline', disabled:true},
  {label:'Facturas', name:'invoices', icon:'mdi-invoice-list-outline', disabled:true},
  {label:'Contacts', name:'contacts', icon:'mdi-contacts-outline', disabled:false},
];


const show_sidebar = ref(true);

const currentTab = ref('sales');

const tabComponents = {
  sales: Sales,
  quotations: Quotations,
  activities: Activities,
  opportunities: Opportunities,
  contacts: Contacts
} as any;

const ActiveTabComponent = computed(() => tabComponents[currentTab.value]);

const props = __props;
const store = useClientsStore();

const client = ref<any>(null);
const loading = ref(true);

onMounted(async () => {
  try {
    loading.value = true;
    client.value = await store.fetchClientById(props.id);
  } catch (e) {
    console.error('[Detail.vue] No se pudo cargar la actividad:', e);
  } finally {
    loading.value = false;
  }
});

const route = useRoute();


const copyLink = async () => {
  // Toma el path actual y reemplaza el id por el del cliente seleccionado (si aplica)
  let path = route.fullPath;

  // Si el path ya tiene un id en los params, cámbialo por el id del cliente actual
  if (route.params.id) {
    path = path.replace(`${route.params.id}`, `${client.value?.id}`);
  } else if (!path.endsWith(`/${client.value?.id}`)) {
    // Si no tiene id en la ruta, se lo agrega al final
    path = path.replace(/\/$/, '') + `/${client.value?.id}`;
  }

  const baseUrl = window.location.origin;
  const fullUrl = baseUrl + path;

  try {
    await navigator.clipboard.writeText(fullUrl);
    // Opcional: Snackbar, toast, etc
    // alert('¡Enlace copiado!');
  } catch (err) {
    alert('No se pudo copiar el enlace');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tool_bar = _resolveComponent("v-tool-bar")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chips = _resolveComponent("v-chips")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_tool_bar, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "ma-0 py-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, {
                class: "py-2",
                style: {"font-size":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2",
                    size: "x-small"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-office-building-outline")
                    ])),
                    _: 1,
                    __: [4]
                  }),
                  _cache[5] || (_cache[5] = _createTextVNode(" Clientes ")),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mx-4" }, "/", -1)),
                  _createVNode(_component_v_avatar, {
                    color: "primary",
                    rounded: "0",
                    size: "small",
                    style: {"border-radius":"10px!important"},
                    class: "mr-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(client.value?.attributes?.commercial_name?.slice(0,1)), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(client.value?.attributes?.commercial_name || client.value?.attributes?.legal_name), 1)
                ]),
                _: 1,
                __: [5,6]
              }),
              _createVNode(GlobalSearchBar, { class: "ml-6 py-1" }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: copyLink
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-small" }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("mdi-content-copy")
                    ])),
                    _: 1,
                    __: [7]
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1,
                    __: [8]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ModulesTab, {
        tabs: tabs,
        modelValue: currentTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTab).value = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          (show_sidebar.value)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                md: "3",
                class: "px-6",
                style: {"max-height":"calc(100vh - 115px)","overflow-y":"scroll"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { style: {"margin-bottom":"-30px","margin-right":"-20px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (show_sidebar.value=false)),
                        icon: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("mdi-chevron-left")
                            ])),
                            _: 1,
                            __: [9]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_title, { class: "pa-0 mb-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "ma-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_avatar, {
                            color: "primary",
                            rounded: "0",
                            style: {"border-radius":"10px!important"},
                            class: "mr-4 mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(client.value?.attributes?.commercial_name?.slice(0,1)), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", {
                              style: _normalizeStyle(client.value?.attributes?.legal_name==null?'line-height:55px;':'')
                            }, _toDisplayString(client.value?.attributes?.commercial_name), 5),
                            _createVNode(_component_v_card_subtitle, { class: "px-0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(client.value?.attributes?.legal_name), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_chips, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_chip, {
                        size: "small",
                        label: "",
                        color: client.value?.attributes?.is_active?'success':'warning',
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { class: "mr-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(client.value?.attributes?.is_active?'mdi-check-circle-outline':'mdi-minus-circle-outline'), 1)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(client.value?.attributes?.is_active?'Activo':'Inactivo'), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      (!client.value?.attributes?.facturapi_id!=null)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            size: "small",
                            label: "",
                            color: "primary",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { class: "mr-2" }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode("mdi-check-circle-outline")
                                ])),
                                _: 1,
                                __: [10]
                              }),
                              _cache[11] || (_cache[11] = _createTextVNode(" CFDI 4.0 "))
                            ]),
                            _: 1,
                            __: [11]
                          }))
                        : _createCommentVNode("", true),
                      (!client.value?.attributes?.facturapi_id!=null)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            size: "small",
                            label: "",
                            color: "white"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { class: "mr-2" }, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                  _createTextVNode("mdi-account-child-circle")
                                ])),
                                _: 1,
                                __: [12]
                              }),
                              _createTextVNode(" " + _toDisplayString(client.value?.attributes?.client_type?.name), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_card_subtitle, { class: "px-0" }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("Responsable")
                      ])),
                      _: 1,
                      __: [13]
                    }),
                    _createVNode(_component_v_row, { class: "ma-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_avatar, {
                          color: "primary",
                          class: "mr-4 mt-2"
                        }, {
                          default: _withCtx(() => [
                            (client.value?.attributes?.user?.profile_photo_path!=null)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 0,
                                  src: client.value?.attributes?.user?.profile_photo_path
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(client.value?.attributes?.commercial_name?.slice(0,1)), 1))
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_v_card_title, {
                            class: "pa-0",
                            style: {"font-size":"15px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(client.value?.attributes?.user?.name + (client.value?.attributes?.user?.last_name!=null?client.value?.attributes?.user?.last_name:'')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_subtitle, {
                            class: "pa-0",
                            style: {"font-size":"13px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(client.value?.attributes?.user?.role), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_icon, { class: "mr-2" }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("mdi-clock-outline")
                      ])),
                      _: 1,
                      __: [14]
                    }),
                    _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Cliente Desde:", -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("span", null, null, -1))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_v_icon, { class: "mr-2" }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("mdi-card-account-details-outline")
                      ])),
                      _: 1,
                      __: [17]
                    }),
                    _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Datos de Contacto", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      (client.value?.attributes?.phone!=null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Teléfono:", -1)),
                            _createTextVNode(" " + _toDisplayString(client.value?.attributes?.phone) + " ", 1),
                            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))
                          ]))
                        : _createCommentVNode("", true),
                      (client.value?.attributes?.email!=null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Email:", -1)),
                            _createTextVNode(" " + _toDisplayString(client.value?.attributes?.email) + " ", 1),
                            _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_icon, { class: "mr-2" }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-invoice-list-outline")
                      ])),
                      _: 1,
                      __: [23]
                    }),
                    _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Datos Fiscales", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      (client.value?.attributes?.tax_id!=null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                            _cache[24] || (_cache[24] = _createElementVNode("strong", null, "RFC:", -1)),
                            _createTextVNode(" " + _toDisplayString(client.value?.attributes?.tax_id) + " ", 1),
                            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1))
                          ]))
                        : _createCommentVNode("", true),
                      (client.value?.attributes?.cfdi_use!=null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _cache[26] || (_cache[26] = _createElementVNode("strong", null, "Uso de CFDI:", -1)),
                            _createTextVNode(" " + _toDisplayString(client.value?.attributes?.cfdi_use) + " ", 1),
                            _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1))
                          ]))
                        : _createCommentVNode("", true),
                      (client.value?.attributes?.bank_account!=null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                            _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Cuenta Bancaria:", -1)),
                            _createTextVNode(" " + _toDisplayString(client.value?.attributes?.bank_account) + " ", 1),
                            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1))
                          ]))
                        : _createCommentVNode("", true),
                      (client.value?.attributes?.tax_system!=null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                            _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Regimen Fiscal:", -1)),
                            _createTextVNode(" " + _toDisplayString(client.value?.attributes?.tax_system), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_v_row, { class: "mx-0 mt-6 mb-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "mr-2" }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createTextVNode("mdi-map-marker-outline")
                        ])),
                        _: 1,
                        __: [32]
                      }),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(client.value?.attributes?.address), 1),
                      _createElementVNode("iframe", {
                        width: "100%",
                        height: "200",
                        class: "my-8",
                        style: {"border":"0"},
                        loading: "lazy",
                        allowfullscreen: "",
                        referrerpolicy: "no-referrer-when-downgrade",
                        src: 'https://www.google.com/maps?q='+client.value?.attributes?.address+'&output=embed'
                      }, null, 8, _hoisted_17)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("Documentos")
                      ])),
                      _: 1,
                      __: [33]
                    }),
                    (client.value?.attributes?.additional_data?.documents)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "ma-0",
                          align: "center",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client.value?.attributes?.additional_data?.documents, (document, index) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                key: index,
                                cols: "auto",
                                class: "pa-0 ma-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, {
                                    href: document?.file,
                                    target: "_blank",
                                    class: "d-flex align-center",
                                    style: {"min-width":"138px","max-width":"138px","min-height":"60px","max-height":"60px","background":"#232324","border-radius":"14px","box-shadow":"0 2px 8px #0006","padding":"8px 8px 8px 8px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_avatar, {
                                        image: "/files/pdf.png",
                                        size: "30",
                                        class: "mr-2"
                                      }),
                                      _createElementVNode("div", _hoisted_18, _toDisplayString(document.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["href"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "12",
            md: show_sidebar.value?9:12,
            class: "pa-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                (!show_sidebar.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "text",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (show_sidebar.value=true)),
                      icon: "",
                      position: "fixed"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[34] || (_cache[34] = [
                            _createTextVNode("mdi-chevron-right")
                          ])),
                          _: 1,
                          __: [34]
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (ActiveTabComponent.value && client.value)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(ActiveTabComponent.value), {
                      class: _normalizeClass(show_sidebar.value?'':'ml-2'),
                      key: ActiveTabComponent.value.__name + '-clientID-'+client.value.id,
                      clientId: client.value.id,
                      client: client.value
                    }, null, 8, ["class", "clientId", "client"]))
                  : _createCommentVNode("", true),
                _createVNode(RightDrawer)
              ])
            ]),
            _: 1
          }, 8, ["md"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})